/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { paperHistoryOrdersSX } from '@/components/content/Account/styles/personal';
import { OrderHistory } from '@/components/content/OrderHistory';
import { Box } from '@mui/material';
import { FC } from 'react';

export const AccountRecentOrders: FC = () => (
	<Box sx={paperHistoryOrdersSX}>
		<OrderHistory />
	</Box>
);
